module.exports = __webpack_public_path__ + "img/bus_day_down_selected.9132e44e.svg";